/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import {replaceSubdomain} from '@morpheus/utils/admin-vue/helpers/api-helper'
import axios from 'axios'
import {
  CodesGeneratorCreateData,
  CodesGeneratorListData,
  CodesGeneratorListItemData,
  NewCodesGenerateData,
  CodesExportData,
  CodesExportsListData,
  CodesExportsListItemData,
  CodesExportsFilesListData,
  CodesExportsFilesListItemData
} from '../types'

const printableCodesBaseURL = replaceSubdomain(process.env.VUE_APP_API_SUBDOMAIN_PRINTABLE_CODES)

export const printableCodesClient = axios.create({
  baseURL: printableCodesBaseURL
})

export function fetchCodesGeneratorList(param: string): Promise<CodesGeneratorListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/generators${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function createCodesGenerator(codesGenerator: CodesGeneratorCreateData): Promise<CodesGeneratorListItemData> {
  return new Promise((resolve, reject) => {
    printableCodesClient.post('/generators', codesGenerator)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchCodesGeneratorById(id: string): Promise<CodesGeneratorListItemData> {
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/generators/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function generateCodes (param: NewCodesGenerateData): Promise<any> {
  return new Promise((resolve, reject) => {
    printableCodesClient.post(`/generators/generate`, param)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function exportCodes (param: CodesExportData): Promise<any> {
  return new Promise((resolve, reject) => {
    printableCodesClient.post(`/generators/export`, param)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchCodesExportsList(param: string): Promise<CodesExportsListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/exports${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchCodesExportsListByGeneratorId(generator_id: string, param: string): Promise<CodesExportsListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/generators/${generator_id}/exports${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchCodesExportById(id: string): Promise<CodesExportsListItemData> {
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/exports/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}


export function fetchCodesExportsFilesList(param: string): Promise<CodesExportsFilesListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/files${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchCodesExportsFilesByExportId(export_id: string): Promise<CodesExportsFilesListData> {
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/exports/${export_id}/files`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchCodesExportsFileById(id: string): Promise<CodesExportsFilesListItemData> {
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/files/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}


export function downloadCodesExportsFileById(id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    printableCodesClient.get(`/download/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function prepareDownloadFileById(id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    printableCodesClient.post(`/preparedownload/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function confirmExport (export_id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    printableCodesClient.post(`/confirm/${export_id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export default {
  fetchCodesGeneratorList,
  createCodesGenerator,
  fetchCodesGeneratorById,
  generateCodes,
  exportCodes,
  fetchCodesExportsList,
  fetchCodesExportsListByGeneratorId,
  fetchCodesExportById,
  fetchCodesExportsFilesList,
  fetchCodesExportsFilesByExportId,
  fetchCodesExportsFileById,
  downloadCodesExportsFileById,
  confirmExport,
  prepareDownloadFileById
}
